// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2670":"dc21be9ffbde9886","2888":"5b25930b92e02c4f","3161":"c4cb069e6eda216d","6858":"dc21be9ffbde9886"}[chunkId] + ".css";
};